// @flow
import React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import moment from 'moment';

import Radio from 'common/domain/radio';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

import History from '../domain/History';
import type { HistoryDateRangeType } from '../domain/HistoryDateRange';
import { asDateRange } from '../domain/HistoryDateRange';
import HistoryGraph from '../components/HistoryGraph';
import HistoryPrintingListing from './components/HistoryPrintingListing';
import PrintingHeader from '../../../../common/modules/printing/components/PrintingHeader';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';

const PageWrapper = styled.div`
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  font-size: 12px;
  margin: 0px auto;
`;

const Header = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.metrics.margin}px;
    margin-bottom: ${theme.metrics.largeMargin}px;
    display: flex;
    flex-direction: column;
    align-items: center;

    div + div {
      margin-top: ${theme.metrics.smallMargin}px;
    }
  `}
`;

const Bold = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;


const Footer = styled.div`
  @media screen {
    display: none;
  }

  position: fixed;
  bottom: 0;
  text-align: center;
  width: 8.5in;
`;

type Props = {
  t: any;
  theme: any;
}

type State = {
  history?: History;
  selectedDateRange?: HistoryDateRangeType;
  radio?: Radio;
  loaded: boolean;
  centralMarket: ?CentralMarket;
}

export class HistoryPrintingPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      history: undefined,
      selectedDateRange: undefined,
      radio: undefined,
      loaded: false,
      centralMarket: undefined,
    };
    setTimeout(() => window.print(), 1000);
  }

  componentWillMount() {
    const data = this.parseData();
    this.setState(data);
  }

  parseData = (): State => {
    const data = PrintingService.getData('HISTORY_PRINTING_DATA');
    if (!data) {
      return {
        history: new History([]),
        selectedDateRange: 'lastMonth',
        radio: undefined,
        loaded: true,
        centralMarket: undefined,
      };
    }

    return {
      history: data.history && History.parse(data.history),
      selectedDateRange: data.selectedDateRange,
      radio: Radio.fromJSON(data.radio),
      loaded: true,
      centralMarket: data.centralMarket && CentralMarket.parse(data.centralMarket),
    };
  };

  render() {
    const { t, theme } = this.props;
    const { radio, selectedDateRange, history, centralMarket, loaded } = this.state;

    if (!radio || !history || !selectedDateRange) {
      return null;
    }

    const dateRange = asDateRange(selectedDateRange);

    return (
      <PrintingPage loading={!loaded}>
        {radio && selectedDateRange && history &&
        <PageWrapper>
          <PrintingHeader radio={radio} centralMarket={centralMarket} />
          <Header>
            <Bold style={{ ...theme.fonts.style.secondary }}>{t('history')
              .toUpperCase()}</Bold>
            <Bold style={{ ...theme.fonts.style.midSmall }}>{t('dateRange', {
              from: dateRange.from,
              to: dateRange.to,
            })}</Bold>
            <Bold style={{ ...theme.fonts.style.small }}>{t('reportCreatedOn', { date: moment() })}</Bold>
          </Header>
          <HistoryGraph data={history} dateRange={selectedDateRange} onClick={() => {
          }} animate={false}
          />
          <HistoryPrintingListing history={history} />
          <Footer>&copy; StatsRadio</Footer>
        </PageWrapper>
        }
      </PrintingPage>
    );
  }
}

export default withTheme(translate('history')(HistoryPrintingPage));



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/printing/HistoryPrintingPage.js